export const dataTestIds = {
	strategyFieldSelect:
		'software-board-settings-card-colors.ui.card-colors-settings-page.card-color-strategy-field.select',
	queryStrategyAddButton:
		'software-board-settings-card-colors.ui.card-colors-settings-page.strategy-content.query-strategy.add',
} as const;
